<script setup lang="ts">
import Banner from '~/shared/ui/banner/Banner.vue';
import {
  BANNER_CHRONICLE_HALVED_A_DESKTOP_PARAMS,
  BANNER_CHRONICLE_HALVED_A_MOBILE_PARAMS,
  BANNER_CHRONICLE_HALVED_A_TABLET_PARAMS,
  BANNER_CHRONICLE_HALVED_B_DESKTOP_PARAMS,
  BANNER_CHRONICLE_HALVED_B_MOBILE_PARAMS,
  BANNER_CHRONICLE_HALVED_B_TABLET_PARAMS,
} from '~/shared/lib/banners';

const isLoaded = ref(false);
</script>

<template>
  <div :class="[$style.banner, { [$style.banner_loaded!]: isLoaded }]">
    <div :class="$style.banner__item">
      <Banner
        :config="[
          BANNER_CHRONICLE_HALVED_A_DESKTOP_PARAMS,
          BANNER_CHRONICLE_HALVED_A_TABLET_PARAMS,
          BANNER_CHRONICLE_HALVED_A_MOBILE_PARAMS,
        ]"
        @loaded="isLoaded = true"
      />
    </div>
    <div :class="$style.banner__item">
      <Banner
        :config="[
          BANNER_CHRONICLE_HALVED_B_DESKTOP_PARAMS,
          BANNER_CHRONICLE_HALVED_B_TABLET_PARAMS,
          BANNER_CHRONICLE_HALVED_B_MOBILE_PARAMS,
        ]"
        @loaded="isLoaded = true"
      />
    </div>
  </div>
</template>

<style module lang="scss">
.banner {
  display: flex;
  flex-flow: row nowrap;
  flex: 1 0 auto;

  &_loaded {
    padding: var(--space-2-5x);
    border-bottom: 1px solid var(--color-gray-line);
  }

  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    flex: 1 0 auto;
  }
}

@media (max-width: 599px) {
  .banner {
    flex-direction: column;
    justify-content: center;

    &_loaded {
      gap: 16px;
    }

    &__item {
      text-align: center;
      width: 100%;
    }
  }
}

@media (max-width: 479px) {
  .banner_loaded {
    padding: var(--space-2x);
  }
}
</style>
